import { parseISO } from 'date-fns'
import { AddressState, EhrCoachGender, EhrCoachRegistrationStatus, EhrCoachSpecialty } from 'types'
import { ICoachProfileFormValues } from './types'

export interface ICoachCredentialsEditableUser {
  id: string
  firstName?: string | null
  lastName?: string | null
  fullName?: string | null
  coachProfile?: {
    registrationStatus?: EhrCoachRegistrationStatus | null
    gender?: EhrCoachGender | null
    stateOfResidence?: string | null
    ethnicity?: string | null
    additionalLanguages?: string | null
    credentials?: string | null
    cdrCnsNumber?: string | null
    cdrCnsExpirationDate?: string | null
    cdrCnsCard?: string | null
    specialties?: Array<{ key: EhrCoachSpecialty }>
    stateLicenceDetails?: Array<{
      state: AddressState
      expirationDate: string
      expirationReminderEnabled?: boolean | null
      document?: string | null
    }> | null
    bio?: string | null
  } | null
}

// Builds the initial form values from the current user's existing coach profile so a
// coach returning after a send-back sees their previously entered data prefilled.
export const mapProfileToDefaults = (
  user: ICoachCredentialsEditableUser | undefined
): ICoachProfileFormValues => {
  const profile = user?.coachProfile

  return {
    firstName: user?.firstName ?? '',
    lastName: user?.lastName ?? '',
    gender: profile?.gender ?? '',
    stateOfResidence: profile?.stateOfResidence ?? '',
    ethnicity: profile?.ethnicity ?? '',
    additionalLanguages: profile?.additionalLanguages ?? '',
    credentials: profile?.credentials ?? '',
    cdrCnsNumber: profile?.cdrCnsNumber ?? '',
    cdrCnsExpirationDate: profile?.cdrCnsExpirationDate
      ? parseISO(profile.cdrCnsExpirationDate)
      : null,
    // Prefill the coach's own saved specialties (empty for a brand-new profile) so a
    // draft or sent-back profile keeps them on reload.
    specialties: profile?.specialties?.map((specialty) => specialty.key) ?? [],
    stateLicences:
      profile?.stateLicenceDetails?.map((row, index) => ({
        uid: index + 1,
        state: row.state,
        expirationDate: parseISO(row.expirationDate),
        expirationReminderEnabled: row.expirationReminderEnabled ?? true,
        file: null,
        existingDocumentUrl: row.document ?? null
      })) ?? [],
    bio: profile?.bio ?? '',
    photo: null,
    cdrCnsCard: null
  }
}
